import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Auth from './components/Auth';
import AuthSuccess from './components/AuthSuccess';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Auth />} />
          <Route path="/auth/success" element={<AuthSuccess />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
